import { CampaignsObject } from '../../modules/AnchorAPI/v3/sponsor/fetchSponsorships';

export function getCampaignsArray(campaigns: CampaignsObject) {
  const { adCampaigns, audios } = campaigns;
  const campaignsArray = adCampaigns.map(adCampaign => {
    const {
      audioId: campaignAudioId,
      exampleAudioId: campaignExampleAudioId,
    } = adCampaign;
    return {
      ...adCampaign,
      audio: audios.find(audioJSON => {
        const { audioId } = audioJSON;
        return audioId === campaignAudioId;
      }),
      exampleAudio: audios.find(audioJSON => {
        const { audioId } = audioJSON;
        return audioId === campaignExampleAudioId;
      }),
    };
  });
  return campaignsArray;
}
